import { EnvironmentInterface } from '@campus/environment';
import { E2eModule } from '../app/e2e/e2e.module';
import { icons } from './icons';
import { svgs } from './svgs';

export const environment: Partial<EnvironmentInterface> = {
  production: true,
  enableDevTools: true,
  svgMapping: svgs,
  iconMapping: icons,
  api: {
    APIBase: 'https://api.staging.kabas.be',
    authBase: 'https://api.staging.kabas.be/auth',
  },

  login: {
    teacherAppUrl: 'https://leerkracht.staging.kabas.be/platform',
    studentAppUrl: 'https://leerling.staging.kabas.be',
    schooladminAppUrl: 'https://beheerder.staging.kabas.be/platform',
    leerId: true,
    qr: true,
    questi: true,
  },
  assets: {
    images: {
      faq: 'https://www.staging.kabas.be/assets/images/faq',
      illustrations: 'https://www.staging.kabas.be/assets/images/illustrations',
      ea: 'https://www.staging.kabas.be/assets/images/ea',
      news: 'https://cdn.staging.kabas.be/avatar/',
    },
    icons: {
      manifest: 'https://www.kabas.be/icons',
    },
  },
  recaptcha: {
    key: '6LcBpPAaAAAAACAV7e6zvf8FeFU5wexkAsIdWKfy',
  },
  googleAnalytics: {
    measurementId: '',
    requireConsent: true,
  },
  afterLogout: {
    url: '/',
    logOutLeerIdUrl: 'https://authenticatie-ti.vlaanderen.be/op/v1/logout',
  },
  website: {
    faqUrl: {
      base: 'https://help.kabas.be/',
      student: 'https://help.kabas.be/content/leerling/',
      teacher: 'https://help.kabas.be/content/leerkracht/',
      admin: 'https://help.kabas.be/content/schoolbeheerder/',
    },
    url: 'https://www.staging.kabas.be',
    statusPageUrl: 'https://status.kabas.be',
  },
  testing: {
    removeDataCyAttributes: false,
  },
  envModules: [E2eModule],
};
